/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// CONTENT TYPE
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
	contenttype: {
		display: 'inline-table',
		marginRight: pxToEm(2),
		position: 'relative',
		verticalAlign: 'middle',
		'&:last-child': {
			marginRight: '0'
		},
		'& .contenttypeinner': {
			borderRadius: pxToEm(12),
			display: 'block',
			width: pxToEm(60), // was 65 (needed to reduce because we added stories)
			height: pxToEm(24)
		},
		'& .icon': {
			background: theme.color.neutral.medium.swatch,
			borderRadius: 'inherit',
			userSelect: 'none',
			color: theme.color.light.light.swatch,
			extend: theme.typography.size.xsmall,
			textTransform: 'lowercase',
			textAlign: 'center',
			display: 'block',
			width: '100%',
			height: '100%',
			transition: 'filter .2s linear 0s',
		},
		'&:hover': {
			'& .icon': {
				filter: 'brightness(85%)'
			},
			// content types
			'&.quiz': {
				'&.live-true, &.selected-true': {
					'& .icon': { filter: 'brightness(100%)' }
				}
			},
			'&.poll': {
				'&.live-true, &.selected-true': {
					'& .icon': { filter: 'brightness(100%)' }
				}
			},
			'&.story': {
				'&.live-true, &.selected-true': {
					'& .icon': { filter: 'brightness(100%)' }
				}
			},
		},

		// content types
		'&.quiz': {
			'&.live-true, &.selected-true': {
                '& .icon': { background: theme.color.quiz.medium.swatch, cursor: 'default', pointerEvents: 'none' }
			}
		},
		'&.poll': {
            '&.live-true, &.selected-true': {
                '& .icon': { background: theme.color.poll.medium.swatch, cursor: 'default', pointerEvents: 'none' }
            }
		},
		'&.story': {
			'&.live-true, &.selected-true': {
				'& .icon': { background: theme.color.story.medium.swatch, cursor: 'default', pointerEvents: 'none' }
			}
		},

		// indicator types
		'&.sort': {
			'& .icon': {
				cursor: 'pointer',
			}
		},
		'&.select': {
			'& .icon': {
				cursor: 'pointer',
			}
		},
		'&.key': {
			'& .icon': {
				cursor: 'default',
			}
		}
	}
});